module.exports = __webpack_public_path__ + "static/media/concessionariaDeAutomoveis.c943341d.jpg";